import axios from 'axios';
import { BASE_URL } from '../config/config';

// const URL = 'http://localhost:3000/externals';
const URL = BASE_URL + '/externals';
const getExternalList = async (keyword, page, limit) => {
  try {
    const response = await axios.get(URL, {
      params: {
        keyword,
        page,
        limit,
      },
    });
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

const createExternal = async (data) => {
  try {
    const result = await axios.post(URL, data);
    console.log(result);
  } catch (error) {
    if (error.response && error.response.data && error.response.data.message) {
      throw new Error(error.response.data.message); // Lempar kesalahan jika ada
    } else {
      throw new Error('There was an error creating the external.');
    }
  }
};

const updateExternal = async (id, data) => {
  try {
    await axios.put(`${URL}/${id}`, data);
  } catch (error) {
    if (error.response && error.response.data && error.response.data.message) {
      throw new Error(error.response.data.message); // Lempar kesalahan jika ada
    } else {
      throw new Error('There was an error creating the external.');
    }
  }
};

const deleteExternal = async (id) => {
  try {
    await axios.delete(`${URL}/${id}`);
  } catch (error) {
    console.log(error);
  }
};

const getExternalById = async (id) => {
  try {
    const result = await axios.get(`${URL}/${id}`);
    return result.data;
  } catch (error) {
    console.log(error);
  }
};

export {
  getExternalList,
  createExternal,
  updateExternal,
  deleteExternal,
  getExternalById,
};
